export const ToastKind = {
  SUCCESS: "Success",
  DONE: "Done",
  ERROR: "Error",
  DELETE: "Delete",
  RESTORE: "Restore",
  COPY: "Copy",
} as const;
export type ToastKindType = (typeof ToastKind)[keyof typeof ToastKind];
